export const GOOGLE_STREETS_ID = 'ROADMAP';
export const GOOGLE_TERRAIN_ID = 'TERRAIN';
export const GOOGLE_SATELLITE_ID = 'HYBRID';
export const GOOGLE_OSM_ID = 'openstreetmap';
export const ESRI_STREETS_ID = 'arcgis-navigation';
export const ESRI_TERRAIN_ID = 'arcgis-terrain';
export const ESRI_SATELLITE_ID = 'arcgis-imagery';
export const ESRI_OSM_ID = 'osm-standard';
export const ESRI_GOOGLE_TILE_TYPE = 'google-tile';

export interface BasemapOption {
  id: string,
  googleMapTypeId?: string,
  googleThumbnail?: string,
  name: string,
  esriMapsDisplayName?: string,
  type: string,
  esriMapTypeId?: string,
  thumbnailUrl?: string,
  esriMapsThumbnailUrl?: string,
  url?: string,
  options?: {
    minZoom: number,
    maxZoom: number
  }
}

const BASEMAPS: BasemapOption[] = [
  {
    id: 'roadmap',
    googleMapTypeId: GOOGLE_STREETS_ID,
    googleThumbnail: 'google-roadmap',
    name: 'Streets',
    esriMapsDisplayName: 'Esri Streets',
    type: 'system',
    esriMapTypeId: ESRI_STREETS_ID,
    thumbnailUrl: 'https://www.arcgis.com/sharing/rest/content/items/61ffcf610f314933916e4b2c0e477b29/info/thumbnail/navigation_thumb_b2.jpg',
    esriMapsThumbnailUrl: 'basemap-thumbnails/basemap_esri-streets.png',
  },
  {
    id: 'terrain',
    googleMapTypeId: GOOGLE_TERRAIN_ID,
    googleThumbnail: 'google-terrain',
    name: 'Terrain',
    esriMapsDisplayName: 'Esri Terrain',
    type: 'system',
    esriMapTypeId: ESRI_TERRAIN_ID,
    thumbnailUrl: 'https://www.arcgis.com/sharing/rest/content/items/1536abe5e5504e5db380ccfaa9b6fd8d/info/thumbnail/Terrain_Labels_Web_map.jpg',
    esriMapsThumbnailUrl: 'basemap-thumbnails/basemap_esri-terrain.png',
  },
  {
    id: 'hybrid',
    googleMapTypeId: GOOGLE_SATELLITE_ID,
    googleThumbnail: 'google-hybrid',
    name: 'Satellite',
    esriMapsDisplayName: 'Esri Satellite',
    type: 'system',
    esriMapTypeId: ESRI_SATELLITE_ID,
    thumbnailUrl: 'https://www.arcgis.com/sharing/rest/content/items/2ea9c9cf54cb494187b03a5057d1a830/info/thumbnail/Jhbrid_thumb_b2.jpg',
    esriMapsThumbnailUrl: 'basemap-thumbnails/basemap_esri-satellite.png',
  },
  {
    id: 'osm',
    googleMapTypeId: GOOGLE_OSM_ID,
    googleThumbnail: GOOGLE_OSM_ID,
    name: 'OpenStreetMap',
    type: 'xyz',
    esriMapTypeId: 'osm-standard',
    thumbnailUrl: 'https://www.arcgis.com/sharing/rest/content/items/c29cfb7875fc4b97b58ba6987c460862/info/thumbnail/thumbnail1547740877120.jpeg',
    esriMapsThumbnailUrl: 'basemap-thumbnails/basemap_osm.png',
    url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
    options: {
      minZoom: 2,
      maxZoom: 18,
    },
  },
  {
    id: 'google-roadmap',
    name: 'Google Streets',
    type: ESRI_GOOGLE_TILE_TYPE,
    esriMapsThumbnailUrl: 'basemap-thumbnails/basemap_google-streets.png',
  },
  {
    id: 'google-satellite',
    name: 'Google Satellite',
    type: ESRI_GOOGLE_TILE_TYPE,
    esriMapsThumbnailUrl: 'basemap-thumbnails/basemap_google-satellite.png',
  },
  {
    id: 'google-terrain',
    name: 'Google Terrain',
    type: ESRI_GOOGLE_TILE_TYPE,
    esriMapsThumbnailUrl: 'basemap-thumbnails/basemap_google-terrain.png',
  },
  {
    id: 'google-hybrid',
    name: 'Google Hybrid',
    type: ESRI_GOOGLE_TILE_TYPE,
    esriMapsThumbnailUrl: 'basemap-thumbnails/basemap_google-hybrid.png',
  },
  {
    id: 'none',
    name: 'None',
    type: 'xyz',
    url: '',
    esriMapsThumbnailUrl: 'basemap-thumbnails/basemap_none.png',
    options: {
      minZoom: 2,
      maxZoom: 22,
    },
  },
];

export const SAFE_DEFAULT_BASEMAP: BasemapOption = BASEMAPS[0];

export default BASEMAPS;
